<template>
  <!-- 新建维修 -->
  <!-- <div v-if="repairShow"> -->
  <el-dialog
    title="新增维修"
    :close-on-click-modal="false"
    @close="close"
    :before-close="close"
    visible
  >
    <el-form
      :model="form"
      ref="form"
      class="repairForm"
      :rules="rules"
      label-width="110px"
      :inline="true"
    >
      <div>
        <!-- 所属社区 -->
        <el-form-item label="所属社区" prop="zoneName">
          <el-select
            v-model="form.zoneName"
            placeholder="请选择所属社区"
            @change="unitChange"
          >
            <el-option
              v-for="(item, index) in zoneList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--报修区域 -->
        <el-form-item label="报修区域" prop="areaBelong">
          <el-radio-group v-model="form.areaBelong">
            <el-radio label="个人房间">个人房间</el-radio>
            <el-radio label="公共区域">公共区域</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-if="houseShow">
        <!-- 报修房源 -->
        <el-form-item label="报修房源" prop="houseName">
          <el-select
            v-model="form.houseName"
            :filterable="remote"
            :remote="remote"
            :remote-method="searchHouse"
            @change="houseNameSelected"
            style="width: 484px"
          >
            <el-option
              v-for="(item, index) in restaurants"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="position: relative">
        <!-- 报修项目 -->
        <span class="require">*</span>
        <el-form-item label="报修项目" prop="">
          <el-cascader
            expand-trigger="hover"
            :options="options"
            @change="getSelectItem"
          >
          </el-cascader>
        </el-form-item>
      </div>
      <div>
        <!-- 维修日期和 维修时间 -->
        <el-form-item label="期望上门日期" prop="serviceDate">
          <el-date-picker
            v-model="form.serviceDate"
            type="date"
            style="width: 176px"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="期望上门时间" prop="serviceTime">
          <el-select v-model="form.serviceTime" style="width: 185px">
            <el-option label="上午" value="上午"></el-option>
            <el-option label="下午" value="下午"></el-option>
            <el-option label="全天" value="全天"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="报修说明" prop="memo">
        <el-input
          type="textarea"
          :rows="2"
          v-model="form.memo"
          style="width: 484px"
        ></el-input>
      </el-form-item>
      <el-form-item label="报修图片" ref="upload">
        <!-- 饿了么上传图片控件 -->
        <el-upload
          :action="ossBaseUrl"
          accept="image/*"
          list-type="picture-card"
          :auto-upload="false"
          :on-change="changeFileList"
          :fileList="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="closeForm('form')">取 消</el-button> -->
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="submit('form')">确 定</el-button>
    </div>
  </el-dialog>
  <!-- </div> -->
</template>
<script>
import co from 'co'
import OSS from 'ali-oss'
import $ from 'jquery'
import houseRescoure1 from './houseRescoure1' //  新建房源
import houseUser from './houseUser' //  新建房源
import workflowApi from '@/xhr/services/workflow'
import accountApi from '@/xhr/services/account'
import houseApi from '@/xhr/services/house'
import contractApi from '@/xhr/services/contract'
// import {date} from '@/filters'
import { k1 } from '@/xhr/services/osssp'
export default {
  data: function () {
    return {
      // 表单验证规则
      rules: {
        zoneName: [
          { required: true, message: '请选择所属社区', trigger: 'change' },
        ],
        areaBelong: [
          { required: true, message: '请选择报修区域', trigger: 'blur' },
        ],
        houseName: [
          { required: true, message: '请选择报修房源', trigger: 'change' },
        ],
        selectedOptions: [{ required: true }],
        serviceDate: [
          {
            type: 'date',
            required: true,
            message: '请选择期望上门日期',
            trigger: 'change',
          },
        ],
        serviceTime: [
          { required: true, message: '请选择期望上门时间', trigger: 'change' },
        ],
        memo: [{ required: true, message: '请填写报修说明', trigger: 'blur' }],
      },
      loading: false,
      uploadData: {
        show: true,
      },
      ossBaseUrl: 'http://' + k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6 + '.' + k1.a_4 + '-' + k1.a_3 + '-' + k1.a_0 + '.' + k1.a_2 + k1.a_8 + k1.a_1 + '.com/',
      fileList: [],
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      landlord: '房东',
      renter: '租客',
      unit: [], // 片区列表
      house: '',
      form: {
        zone: '',
        unitId: '',
        keywordAddress: '',
        houseSpaceId: '',
        date: null,
        time: null,
        goodList1: '',
        goodList2: '',
        goodList3: '',
        imglist: [],
        maintainedItems: [
          {
            goodType: 'E_METER',
            goodLists: [],
            itemId: '',
          },
        ],
        // maintainedItemIds: [],
        memo: '',
        serverType: 'MAINTAIN',
        areaBelong: '',
        // 租客ID
        renterId: '',
      },
      restaurants: [],
      remote: true,
      goodTypeList: [
        {
          value: 'E_METER',
          label: '电表',
        },
        {
          value: 'W_METER',
          label: '水表',
        },
        {
          value: 'G_METER',
          label: '煤气表',
        },
        {
          value: 'DOOR_LOCK',
          label: '门锁',
        },
        {
          value: 'FURNITURE',
          label: '家具',
        },
        {
          value: 'HA',
          label: '家电',
        },
        {
          value: 'RESTS',
          label: '其他',
        },
        {
          value: 'BROAD_BAND',
          label: '宽带',
        },
      ],
      goodList: [],
      goodLists1: [],
      goodLists2: [],
      goodLists3: [],
      mix: {
        treeArea: this.$store.state.accountUrl + 'unit/tree/f/area', // 查询片区
        houseList: this.$store.state.houseUrl + 'list/houseSpace', // 房源地址查找
        list: this.$store.state.houseUrl + 'list/fixedAssets', // 物品列表
        goodListUrl: this.$store.state.categoryUrl + 'repair_category/all', // 物品列表
      },
      clickOver: true,

      // 操作人手机号码
      userPhone: this.$store.state.currentUser.UserPhone,
      zoneList: [], // 片区集合
      options: [],
      maintainThingInfo: '', // 选取的维修项目 文字信息
      mtIsMessage: false, // 是否需要标红的项
      selectedOptions2: [],
      unitType: '', // 社区类型 分散式还是集中式
      waiter: null,
      houseWaiter: null,
    }
  },
  props: ['addclickCount', 'repairShow'],
  created: function () {
    // console.log(this.userPhone)
    this.$options.methods.getGoodLists(this, true)
    // 获取 片区列表
    this.getUserZoneList(this.userPhone)
    // 获取 维修项目下拉数据
    this.getMaintainThing()
    // console.log(this.$route.name)
  },
  computed: {
    houseShow() {
      // console.log(this.form.areaBelong, this.unitType)
      if (
        this.unitType === 'DISTRIBUTED' ||
        (this.unitType === 'CENTRALIZED' && this.form.areaBelong === '个人房间')
      ) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    addclickCount: function (value) {
      this.$options.methods.unitSelect(this)
      this.form.goodList1 = ''
      this.form.goodList2 = ''
      this.form.goodList3 = ''
      this.$options.methods.getGoodLists(this, true)
      let list = {}
      list.zone = ''
      list.unitId = ''
      list.keywordAddress = ''
      list.houseSpaceId = ''
      list.maintainedItems = []
      list.memo = ''
      list.serverType = 'MAINTAIN'
      let list1 = {}
      list1.goodType = 'E_METER'
      list1.itemId = ''
      list1.goodLists = []
      list.maintainedItems.push(list1)
      this.form = { ...this.form, ...list }
      this.house = ''
      this.clickOver = true
    },
    $route: function (val, oldval) {
      // console.log(val.name)
    },
  },
  mounted() {
    $('.el-dialog--small,.el-dialog--tiny').width(650)
  },
  methods: {
    // 改变文件列表

    changeFileList(file, fileList) {
      // (raw, name, size, uid, url)
      this.fileList = fileList
    },
    close() {
      this.$emit('closeRepair')
    },

    closeForm(form) {
      this.$emit('closeForm')
      this.$options.methods.bgForm(this)
      this.$refs[form].resetFields()
      this.mtIsMessage = false
      this.restaurants = []
      // this.zoneList = []
      // this.options = []
      this.maintainThingInfo = ''
      this.selectedOptions2 = ''
      this.unitType = ''
    },
    show() {},
    remoteMethod(queryString) {
      // 小区远程搜索，支持区域id+名称传值
      if (queryString !== '') {
        let url = this.$store.state.searchUrl + 'query/jurisdiction'
        let req = {}
        req.keyword = queryString
        req.esType = 'HOUSE_SPACE'
        req.pageNumber = 1
        req.pageSize = 10
        req.loginId = this.$store.state.currentUser.uid
        req.searchType = 'MATCH_PHRASE'
        this.restaurants = []
        this.$http.post(url, req).then(({ data }) => {
          if (data.code === 200) {
            let list = []
            list = data.data.list
            for (var p in list) {
              let restaurant = {}
              restaurant.value = list[p].keywordAddress
              restaurant.zoneId = list[p].zoneId
              restaurant.houseSpaceId = list[p].houseSpaceId
              this.restaurants.push(restaurant)
            }
          }
        })
      }
    },
    createFilter(queryString) {
      // 小区信息
      return (restaurant) => {
        return restaurant.value.indexOf(queryString.toLowerDae()) === 0
      }
    },
    handleSelect(item) {
      // 选择小区信息
      this.form.houseSpaceId = item.houseSpaceManagerId
    },
    unitSelect(_this) {
      // 搜索片区
      let url = _this.$store.state.accountUrl + 'unit/tree/f/area'
      _this.$http.get(url).then(({ data }) => {
        var data1 = data.data.children[0].children
        _this.unit = data1
        _this.form.unitId = _this.unit[0].id
        _this.form.zone = _this.unit[0].text
      })
    },
    zoneChange(data) {
      // 选择片区
      this.form.zoneId = data
    },
    goodTypeChange(value) {
      let req = {}
      req.houseSpaceId = this.form.houseSpaceId
      req.fixedAssetsType = value.goodType
      req.houseSpaceType = 'HOUSE_SPACE'
      this.$options.methods.goodSearch(this, this.mix.list, req, value)
    },
    houseChange(value) {
      let list = {}
      list.goodType = 'E_METER'
      list.goodName = ''
      list.goodLists = []
      this.form.maintainedList = []
      this.form.maintainedList.push(list)
      this.form.zoneId = value.zoneId
      this.form.addr = value.value
      this.form.mHouseId = value.houseSpaceId
      let req = {}
      req.houseSpaceId = this.form.houseSpaceId
      req.fixedAssetsType = 'E_METER'
      req.houseSpaceType = 'HOUSE_SPACE'
      this.$options.methods.goodSearch(
        this,
        this.mix.list,
        req,
        this.form.maintainedItems[0]
      )
    },
    goodSearch(_this, url, req, value) {
      value.goodLists = []
      value.itemId = '0'
      _this.$http.post(url, req).then(function (res) {
        if (res.body.code === 200) {
          value.goodLists = res.body.data[0].resFixedAssetsBeanList
          value.itemId = res.body.data[0].resFixedAssetsBeanList[0].id
        }
      })
    },
    goodNameChange(index, value) {
      this.form.maintainedList[index].goodName = value
    },
    // 根据本地图片列表上传
    uploadFileList(fileList) {
      const registerToken = (fileCount) => {
        return new Promise((resolve, reject) => {
          this.$http
            .post(this.urljoin(this.urlList.pdf, 'token'), {
              fileCount,
              ossType: 'image',
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(`上传失败。原因：${res.data.message}`)
                reject()
              } else {
                resolve(res.data.data)
              }
            })
        })
      }

      return new Promise((resolve, reject) => {
        registerToken(fileList.length).then(({ key, secret, fileNames }) => {
          const client = new OSS({
            region: k1.a_4 + '-cn-' + k1.a_0,
            accessKeyId: key,
            accessKeySecret: secret,
            bucket: k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6
          })

          co(function* () {
            let ret = []
            for (let i = 0; i < fileNames.length; i++) {
              const o = yield client.put(fileNames[i], fileList[i].raw)
              ret.push(o)
            }
            resolve(ret)
          }).catch((err) => {
            this.$message.error(`OSS上传失败。原因：${err.code}`)
            reject()
          })
        })
      })
    },
    submit(form) {
      // 提交
      // 限制单位时间内触发导出次数
      clearTimeout(this.waiter)
      this.waiter = setTimeout(() => {
        this.$refs[form].validate((valid) => {
          if (valid) {
            // 校验 维修项目
            if (!this.maintainThingInfo) {
              this.$message.warning('请选择报修项目')
              return
            }
            this.loading = true
            // console.log(this.restaurants)
            let param = {
              initiator: this.$store.state.currentUser.uid, // 当前用户
              processBusinessKey: 'process-repair-keeper-v1', // 流程key
              processInstanceName: 'form-maintain-request-def', // 流程名称
              processScopeId: this.form.zoneName, // 片区id
              variables: {
                mtZoneId: this.form.zoneName, // 社区ID
                mtZoneName: this.getOptionName(
                  this.zoneList,
                  this.form.zoneName
                ),
                mtAreaBelong: this.form.areaBelong,
                mtHouseName: this.houseShow ? this.restaurants[0].name : '',
                mtHouseId: this.houseShow ? this.form.houseName : '',
                mtThing: this.maintainThingInfo,
                mtServiceDate: new Date(this.form.serviceDate).getTime(),
                mtServiceTime: this.form.serviceTime,
                mtImages: [],
                mtRemark: this.form.memo,
                mtIsMessage: this.mtIsMessage,
                mtThingId: this.selectedOptions2[
                  this.selectedOptions2.length - 1
                ],
                mtHouseKeeperId: this.houseShow
                  ? this.restaurants[0].housekeeperId
                  : '',
                mtLoginId: this.$store.state.currentUser.uid,
                mtRenterId: this.houseShow ? this.form.renterId : '',
                mtStartUserId: this.$store.state.currentUser.uid,
              },
            }
            if (this.fileList.length === 0) {
              this.clickOver = true
              const urls = []
              param.variables.mtImages = JSON.stringify(urls) // 报修图片列表
              this.repairAdd(param)
            } else {
              this.uploadFileList(this.fileList).then((list) => {
                this.clickOver = true
                const urls = list.map((it) => it.url)
                // 上传成功后 提交新建流程部分
                param.variables.mtImages = JSON.stringify(urls) // 报修图片列表
                this.repairAdd(param)
              })
            }
          } else {
            console.log('error submit!!')
            this.loading = false
            return false
          }
        })
      }, 500)
      // if (this.clickOver) {
      //   this.clickOver = false
      //   let count = 0
      //   //   if (this.form.maintainedItems[i].itemId === '') {
      //   //     count++

      //   // }
      //   if (count > 0) {
      //     this.$message({
      //       message: '请选择维修物品',
      //       type: 'error'
      //     })
      //     this.clickOver = true
      //   } else if (this.form.list1 === '') {
      //     this.$message({
      //       message: '请选择详细地址',
      //       type: 'error'
      //     })
      //     this.clickOver = true
      //   } else if (this.form.date === '') {
      //     this.$message({
      //       message: '请选择上门日期',
      //       type: 'error'
      //     })
      //     this.clickOver = true
      //   } else if (this.form.time === '') {
      //     this.$message({
      //       message: '请选择上门时间',
      //       type: 'error'
      //     })
      //     this.clickOver = true
      //   } else if (this.form.memo === '') {
      //     this.$message({
      //       message: '请填写报修说明',
      //       type: 'error'
      //     })
      //     this.clickOver = true
      //   } else {
      //   // 图片为非必传字段
      //   // else if (this.fileList.length === 0) {
      //   //   this.$message({
      //   //     message: '请上传报修图片',
      //   //     type: 'error'
      //   //   })
      //   //   this.clickOver = true
      //   // }
      //     // TODO :代码重构还是基于原来的做修改
      //     // 上传文件列表
      //     // 传递参数
      //     let param = {
      //           initiator: this.$store.state.currentUser.uid, // 当前用户
      //           processBusinessKey: 'process-maintain-v1', // 流程key
      //           processInstanceName: '维保流程', // 流程名称
      //           processScopeId: this.form.zoneId, // 片区id
      //           variables: {
      //             mtAddress: this.form.addr, // 片区地址
      //             mtServiceDate: date(this.form.date), // 报修日期
      //             mtServiceTime: this.form.time, // 报修时间
      //             mtRemark: this.form.memo, // 报修备注
      //             // mtRoomType: this.form.goodList1, // 报修房间
      //             // mtThingType: this.form.goodList2, // 房间分类
      //             mtThing: `${this.form.goodList1}/${this.form.goodList2}/${this.form.goodList3}`, // 报修项目
      //             mtHouseId: this.form.mHouseId
      //           }
      //     }
      //    if (this.fileList.length === 0) {
      //         this.clickOver = true
      //         const urls = []
      //         param.variables.mtImages = JSON.stringify(urls) // 报修图片列表
      //         this.repairAdd(param)

      //    } else {
      //         this.uploadFileList(this.fileList).then(list => {
      //           this.clickOver = true
      //           const urls = list.map(it => it.url)
      //           // 上传成功后 提交新建流程部分
      //           param.variables.mtImages = JSON.stringify(urls) // 报修图片列表
      //           this.repairAdd(param)
      //       })
      //    }
      //   }
      //   }
    },
    // 新增维保
    repairAdd(param) {
      // 新建流程的接口部分
      // console.log(param)
      workflowApi.process.newProcessInstance(param).then((res) => {
        this.clickOver = true
        if (res.data.code === 200) {
          // console.log(this.$route)
          this.$message({
            type: 'success',
            message: '添加成功',
          })
          if (this.$route.name === 'tasks') {
            this.$root.bus.$emit('refreshTask')
          }
          this.close()
          this.loading = false
        } else {
          let message = ''
          if (res.data.message) {
            message = res.data.message
          } else {
            message = '发起失败'
          }
          this.$message({
            type: 'error',
            // message: res.data.message
            message: message,
          })
          this.loading = false
        }
      })
    },
    // 初始化form
    bgForm(_this) {
      let list = {}
      list.zone = ''
      list.unitId = ''
      list.keywordAddress = ''
      list.houseSpaceId = ''
      list.maintainedItems = []
      list.memo = ''
      list.serverType = 'MAINTAIN'
      let list1 = {}
      list1.goodType = 'E_METER'
      list1.itemId = ''
      list1.goodLists = []
      list.maintainedItems.push(list1)
      _this.fileList = []
      // _this.$refs.upload.clearFiles()// 清除选择的文件
      _this.form = list
    },
    addGoodType() {
      // 新增物品选项
      let list = {}
      list.goodType = 'E_METER'
      list.itemId = ''
      list.goodLists = []

      let req = {}
      req.houseSpaceId = this.form.houseSpaceId
      req.fixedAssetsType = 'E_METER'
      this.$options.methods.goodSearch(this, this.mix.list, req, list)
      this.form.maintainedItems.push(list)
    },
    reduceGoodType(index) {
      // 删除当前物品
      this.form.maintainedItems.splice(index, 1)
    },
    goodChoose(value) {},
    // 设定好默认选择的商品,init代表是第一次渲染
    getGoodLists(_this, init) {
      _this.$http.post(_this.mix.goodListUrl).then(function (res) {
        if (res.body.code === 200) {
          _this.goodLists1 = res.body.data
          _this.goodLists2 = res.body.data[0].children
          _this.goodLists3 = res.body.data[0].children[0].children
          if (init) {
            _this.form.goodList1 = _this.goodLists1[0].categoryName
            _this.form.goodList2 = _this.goodLists2[0].categoryName
            _this.form.goodList3 = _this.goodLists3[0].categoryName
          }
        }
      })
    },
    goodListChange1(value) {
      this.form.goodList1 = value
      for (let i = 0; i < this.goodLists1.length; i++) {
        if (value === this.goodLists1[i].categoryName) {
          this.goodLists2 = this.goodLists1[i].children
          this.form.goodList2 = this.goodLists2[0].categoryName
        }
      }
    },
    goodListChange2(value) {
      this.form.goodList2 = value
      for (let i = 0; i < this.goodLists2.length; i++) {
        if (value === this.goodLists2[i].categoryName) {
          this.goodLists3 = this.goodLists2[i].children
          this.form.goodList3 = this.goodLists3[0].categoryName
        }
      }
    },
    goodListChange3(value) {
      this.form.goodList3 = value
    },

    // 根据操作人 手机获取所属片区集合
    getUserZoneList(val) {
      if (val) {
        accountApi.getUserInfoOfZone(val).then((res) => {
          if (res.data.code === 200 && res.data.data.unitBeans) {
            // 公司Id 集合
            let companyIdArr = res.data.data.unitBeans.map((item) => item.id)
            this.getChildrenUnits(companyIdArr)
          } else {
            this.$message.warning('获取不到片区集合')
          }
        })
      }
    },
    // 根据 片区ID集合，获取对应社区集合
    getChildrenUnits(arr) {
      if (arr && arr.length) {
        let params = {
          unitId: arr,
        }
        accountApi.getAllChildrenUnitsById(params).then((res) => {
          if (res.data.code === 200 && res.data.data.length) {
            this.zoneList = res.data.data
          }
        })
      }
    },
    // 选取所属社区
    unitChange(val) {
      let unit = this.zoneList.find((item) => item.id === val)
      this.unitType = unit.unitRentType || 'CENTRALIZED' // 获取所选社区的 类型
    },
    // 根据关键字搜索房源信息
    searchHouse(query) {
      // 限制单位时间内触发导出次数
      clearTimeout(this.waiter)
      this.waiter = setTimeout(() => {
        if (query) {
          if (this.form.zoneName) {
            let unitIdList = []
            unitIdList.push(this.form.zoneName)
            let params = {
              keywordAddress: query,
              zoneId: this.form.zoneName,
            }
            houseApi.house.getMaintainHouseList(params).then((res) => {
              if (res.data.code === 200 && res.data.data.length) {
                let restaurant = []
                res.data.data.forEach((item) => {
                  let obj = {}
                  obj.name = item.keywordAddress
                  obj.id = item.houseSpaceId
                  obj.housekeeperId = item.housekeeperId
                  obj.propertyType = item.propertyType
                  restaurant.push(obj)
                })
                this.restaurants = restaurant // 赋值
                // console.log(this.restaurants)
              } else {
                // this.$message.warning('暂无房源数据')
                this.restaurants = []
              }
            })
          } else {
            this.$message.warning('请先选择所属社区')
          }
        } else {
          this.restaurants = []
        }
      }, 500)
    },
    //
    houseNameSelected(val) {
      // console.log(val)
      if (val) {
        this.getRenterInfoFromHouseId(val)
      }
      // console.log(this.restaurants)
    },
    // 根据 房源ID 获取租客信息
    getRenterInfoFromHouseId(id) {
      if (id) {
        contractApi.contract.getEffectContractInform(id).then((res) => {
          if (res.data.code === 200 && res.data.data) {
            this.form.renterId = res.data.data
          } else {
            this.form.renterId = ''
          }
        })
      }
    },
    // 维修项目下拉框
    getSelectItem(val) {
      // console.log(val)
      this.selectedOptions2 = val
      // console.log(this.selectedOptions2)
      let [value1, value2, value3] = val
      let maintainWordArr = []
      // 过滤 维修项目的数据，获取已选取的数据，并加工
      let obj = this.options.find((item) => {
        if (item.value === value1 && item.hasSon) {
          maintainWordArr.push(item.label)
          return item.children.find((item) => {
            if (item.value === value2 && item.hasSon) {
              maintainWordArr.push(item.label)
              return item.children.find((item) => {
                if (item.value === value3) {
                  maintainWordArr.push(item.label)
                  this.mtIsMessage = item.isMessage
                  return item
                }
              })
            }
          })
        }
      })
      if (maintainWordArr.length === 3) {
        this.maintainThingInfo = maintainWordArr.join('/')
      }
      console.log(obj)
    },

    getOptionName(list, id) {
      if (list && list.length) {
        let name = list.find((item) => item.id === id).name
        return name
      }
    },
    // 获取维修项目 数据 并处理
    getMaintainThing() {
      let params = {
        enumRepairBusinessType: 'THING', // THING 代表 维修项目数据
      }
      workflowApi.process.getMaintainThingMessage(params).then((res) => {
        if (
          res.data.code === 200 &&
          res.data.data.children[0].children.length
        ) {
          let option = res.data.data.children[0].children
          // console.log(option)
          this.options = option
        }
      })
    },
  },
  // updated () {
  //   this.getNewWorkflowToken('maintain', {})
  // },
  components: {
    houseRescoure1,
    houseUser,
  },
}
</script>
<style scoped>
.houseSizeP {
  display: inline-block;
  margin-left: -30px;
  position: relative;
}
.dialog-footer {
  text-align: center;
  text-align: right;
  padding-right: 35px;
}
.add {
  position: absolute;
  top: 0;
  right: 0px;
  width: 16px;
  height: 36px;
  background: url('../../static/img/add.png') center center / 16px 16px;
  background-repeat: no-repeat;
  cursor: pointer;
  display: none;
}
.reduce {
  position: absolute;
  top: 0;
  right: 0px;
  width: 16px;
  height: 36px;
  background: url('../../static/img/reduce.png') center center / 16px 16px;
  background-repeat: no-repeat;
  cursor: pointer;
  display: block;
}
.repairForm .goodList1 {
  margin-top: 0;
  position: relative;
}
.repairForm .goodList1.firstList {
  padding-top: 0px;
  border-top-width: 0;
}
.repairForm .goodList1.lastList .reduce {
  display: none;
}
.repairForm .goodList1.lastList .add {
  display: block;
}
.require {
  color: #ff4949;
  position: absolute;
  left: 32px;
  top: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/repairAdd.vue